<template></template>
<script>
import { mapGetters, mapActions } from 'vuex';

export default {
  data() {
    return {
    };
  },
  mounted() {
  },
  computed: {
    ...mapGetters({
      currentlyLoadedIslandLevel: 'contents/currentlyLoadedIslandLevel',
      loggedInUserProfile: 'users/loggedInUserProfile',
    }),
    detectThematicBackgroundColor() {
      if (this.$route.name === 'Thematic') {
        switch (this.loggedInUserProfile.user.currentIsland) {
          case 0:
            return '#fff1f1';
          case 1:
            return '#eff7fe';
          case 2:
            return '#f0f3ed';
          case 3:
            return '#fef8ee';
          case 4:
            return '#fbf1f4';
          case 5:
            return '#ebf6f4';
          case 6:
            return '#f5f8f1';
          case 7:
            return '#f1f9f8';
          case 8:
            return '#f2f0f5';
          case 9:
            return '#fefbfb';
          case 10:
            return '#f2f0f5';
          case 11:
            return '#fef6f2';
          case 12:
            return '#f8f2f6';
          default:
            return '#dfdfdf';
        }
      } else if (this.$route.name === 'Island') {
          switch (this.loggedInUserProfile.user.currentIsland) {
            case 0:
              return {
                image: 1,
                color: '#ff6a6a',
              };
            case 1:
              return {
                image: 2,
                color: '#48b0f7',
              };
            case 2:
              return {
                image: 3,
                color: '#638343',
              };
            case 3:
              return {
                image: 4,
                color: '#fab62f',
              };
            case 4:
              return {
                image: 5,
                color: '#d75f83',
              };
            case 5:
              return {
                image: 6,
                color: '#23a081',
              };
            case 6:
              return {
                image: 7,
                color: '#9ebd6f',
              };
            case 7:
              return {
                image: 8,
                color: '#5ABCB3',
              };
            case 8:
              return {
                image: 9,
                color: '#8394B0',
              };
            case 9:
              return {
                image: 10,
                color: '#A78C8C',
              };
            case 10:
              return {
                image: 11,
                color: '#A399BB',
              };
            case 11:
              return {
                image: 12,
                color: '#E8905F',
              };
            case 12:
              return {
                image: 13,
                color: '#B46DA1',
              };
            default:
              return '#48b0f7';
          }
      } else {
        return undefined;
      }
    },
    detectThematicColor() {
      if (this.$route.name === 'Thematic') {
        switch (this.loggedInUserProfile.user.currentIsland) {
          case 0:
              return 'var(--notificationRed)';
            case 1:
              return 'var(--primaryBlue)';
            case 2:
              return '#638343';
            case 3:
              return '#fab62f';
            case 4:
              return '#d75f83';
            case 5:
              return 'var(--iconMessageGreen)';
            case 6:
              return 'var(--iconRead)';
            case 7:
              return '#5ABCB3';
            case 8:
              return '#8394B0';
            case 9:
              return '#A78C8C';
            case 10:
              return '#A399BB';
            case 11:
              return '#E8905F';
            case 12:
              return '#B46DA1';
            default:
              return 'var(--primaryBlue)';
        }
      } else {
        return undefined;
      }
    },
    proPromotionColor() {
      if (this.$route.name === 'Thematic') {
        switch (this.loggedInUserProfile.user.currentIsland) {
          case 0:
              return '#A24546';
            case 1:
              return '#4092C9';
            case 2:
              return '#40542B';
            case 3:
              return '#9F7429';
            case 4:
              return '#923D57';
            case 5:
              return '#116B55';
            case 6:
              return '#708A49';
            case 7:
              return '#3A7F78';
            case 8:
              return '#4D5C75';
            case 9:
              return '#826868';
            case 10:
              return '#463962';
            case 11:
              return '#BA7752';
            case 12:
              return '#78476C';
            default:
              return '#A24546';
        }
      } else {
        return undefined;
      }
    },
  },
  methods: {
    detectPulsationColor(level) {
      switch (level) {
        case 0:
          return '#FD8687';
        case 1:
          return '#7CC6F7';
        case 2:
          return '#7F9964';
        case 3:
          return '#F9C25E';
        case 4:
          return '#DE7E9A';
        case 5:
          return '#44B19B';
        case 6:
          return 'var(--iconRead)';
        case 7:
          return '#5ABCB3';
        case 8:
          return '#8394B0';
        case 9:
          return '#A78C8C';
        case 10:
          return '#584A7B';
        case 11:
          return '#E8905F';
        case 12:
          return '#B46DA1';
        default:
          return '#7cc6f7';
      }
    },
  },
};
</script>

